import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Empresa } from '../../entities/empresa';
import { Api } from '../../providers/api/api';

import * as _ from 'lodash';

interface IndicadorProducaoCorteMultiloja {
    QuantidadeCalcinhaDia: number;
    QuantidadeCalcinhaMes: number;
    QuantidadeCalcinhaAno: number;
    QuantidadeSutiaDia: number;
    QuantidadeSutiaMes: number;
    QuantidadeSutiaAno: number;
    QuantidadeModeladorDia: number;
    QuantidadeModeladorMes: number;
    QuantidadeModeladorAno: number;
    TotalPecasDia: number;
    TotalPecasMes: number;
    TotalPecasAno: number;
    Empresa: Empresa;
}

@Component({
    selector: 'indicador-pro-corte-multilojas',
    templateUrl: './indicador-pro-corte-multilojas.html'
})
export class IndicadorProducaoCorteMultilojasComponent implements OnInit, OnDestroy {
    @Input('analytic') analytic: boolean = false;

    public data: Date = new Date();

    public producaoMultilojaDilady: IndicadorProducaoCorteMultiloja;
    public producaoMultilojaLoveSecret: IndicadorProducaoCorteMultiloja;
    public producaoMultilojaBanhoDeMar: IndicadorProducaoCorteMultiloja;
    public producaoMultilojaDoctorSecret: IndicadorProducaoCorteMultiloja;
    public producaoMultilojaGrupo: any;

    public carregandoDados: boolean = true;

    private _myInterval: number;

    constructor(
        private _api: Api
    ) { }

    public ngOnInit(): void {
        this._separarLojas();

        this._myInterval = setInterval(() => {
            this._separarLojas();
        }, 30000);
    }

    public ngOnDestroy(): void {
        clearInterval(this._myInterval);
    }

    private _separarLojas(): void {
        this._obterIndicadorProducaoCorteMultiloja().then(indicadores => {
            this.producaoMultilojaDilady = indicadores.find(a => _.isEqual(a.Empresa.Id, 1));
            this.producaoMultilojaDilady.TotalPecasDia = (this.producaoMultilojaDilady.QuantidadeCalcinhaDia + this.producaoMultilojaDilady.QuantidadeSutiaDia + this.producaoMultilojaDilady.QuantidadeModeladorDia);
            this.producaoMultilojaDilady.TotalPecasMes = (this.producaoMultilojaDilady.QuantidadeCalcinhaMes + this.producaoMultilojaDilady.QuantidadeSutiaMes + this.producaoMultilojaDilady.QuantidadeModeladorMes);
            this.producaoMultilojaDilady.TotalPecasAno = (this.producaoMultilojaDilady.QuantidadeCalcinhaAno + this.producaoMultilojaDilady.QuantidadeSutiaAno + this.producaoMultilojaDilady.QuantidadeModeladorAno);

            this.producaoMultilojaLoveSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 2));
            this.producaoMultilojaLoveSecret.TotalPecasDia = (this.producaoMultilojaLoveSecret.QuantidadeCalcinhaDia + this.producaoMultilojaLoveSecret.QuantidadeSutiaDia + this.producaoMultilojaLoveSecret.QuantidadeModeladorDia);
            this.producaoMultilojaLoveSecret.TotalPecasMes = (this.producaoMultilojaLoveSecret.QuantidadeCalcinhaMes + this.producaoMultilojaLoveSecret.QuantidadeSutiaMes + this.producaoMultilojaLoveSecret.QuantidadeModeladorMes);
            this.producaoMultilojaLoveSecret.TotalPecasAno = (this.producaoMultilojaLoveSecret.QuantidadeCalcinhaAno + this.producaoMultilojaLoveSecret.QuantidadeSutiaAno + this.producaoMultilojaLoveSecret.QuantidadeModeladorAno);

            this.producaoMultilojaBanhoDeMar = indicadores.find(a => _.isEqual(a.Empresa.Id, 3));
            this.producaoMultilojaBanhoDeMar.TotalPecasDia = (this.producaoMultilojaBanhoDeMar.QuantidadeCalcinhaDia + this.producaoMultilojaBanhoDeMar.QuantidadeSutiaDia + this.producaoMultilojaBanhoDeMar.QuantidadeModeladorDia);
            this.producaoMultilojaBanhoDeMar.TotalPecasMes = (this.producaoMultilojaBanhoDeMar.QuantidadeCalcinhaMes + this.producaoMultilojaBanhoDeMar.QuantidadeSutiaMes + this.producaoMultilojaBanhoDeMar.QuantidadeModeladorMes);
            this.producaoMultilojaBanhoDeMar.TotalPecasAno = (this.producaoMultilojaBanhoDeMar.QuantidadeCalcinhaAno + this.producaoMultilojaBanhoDeMar.QuantidadeSutiaAno + this.producaoMultilojaBanhoDeMar.QuantidadeModeladorAno);

            this.producaoMultilojaDoctorSecret = indicadores.find(a => _.isEqual(a.Empresa.Id, 5));
            this.producaoMultilojaDoctorSecret.TotalPecasDia = (this.producaoMultilojaDoctorSecret.QuantidadeCalcinhaDia + this.producaoMultilojaDoctorSecret.QuantidadeSutiaDia + this.producaoMultilojaDoctorSecret.QuantidadeModeladorDia);
            this.producaoMultilojaDoctorSecret.TotalPecasMes = (this.producaoMultilojaDoctorSecret.QuantidadeCalcinhaMes + this.producaoMultilojaDoctorSecret.QuantidadeSutiaMes + this.producaoMultilojaDoctorSecret.QuantidadeModeladorMes);
            this.producaoMultilojaDoctorSecret.TotalPecasAno = (this.producaoMultilojaDoctorSecret.QuantidadeCalcinhaAno + this.producaoMultilojaDoctorSecret.QuantidadeSutiaAno + this.producaoMultilojaDoctorSecret.QuantidadeModeladorAno);


            this.producaoMultilojaGrupo = {
                QuantidadeCalcinhaDia: _.sum(indicadores.map(a => a.QuantidadeCalcinhaDia)),
                QuantidadeCalcinhaMes: _.sum(indicadores.map(a => a.QuantidadeCalcinhaMes)),
                QuantidadeCalcinhaAno: _.sum(indicadores.map(a => a.QuantidadeCalcinhaAno)),
                QuantidadeSutiaDia: _.sum(indicadores.map(a => a.QuantidadeSutiaDia)),
                QuantidadeSutiaMes: _.sum(indicadores.map(a => a.QuantidadeSutiaMes)),
                QuantidadeSutiaAno: _.sum(indicadores.map(a => a.QuantidadeSutiaAno)),
                QuantidadeModeladorDia: _.sum(indicadores.map(a => a.QuantidadeModeladorDia)),
                QuantidadeModeladorMes: _.sum(indicadores.map(a => a.QuantidadeModeladorMes)),
                QuantidadeModeladorAno: _.sum(indicadores.map(a => a.QuantidadeModeladorAno)),
                TotalPecasDia: (this.producaoMultilojaDilady.TotalPecasDia + this.producaoMultilojaLoveSecret.TotalPecasDia + this.producaoMultilojaBanhoDeMar.TotalPecasDia),
                TotalPecasMes: (this.producaoMultilojaDilady.TotalPecasMes + this.producaoMultilojaLoveSecret.TotalPecasMes + this.producaoMultilojaBanhoDeMar.TotalPecasMes),
                TotalPecasAno: (this.producaoMultilojaDilady.TotalPecasAno + this.producaoMultilojaLoveSecret.TotalPecasAno + this.producaoMultilojaBanhoDeMar.TotalPecasAno)
            }

            setTimeout(() => {
                this.carregandoDados = false;
            }, 1000);
        }).catch(error => {
            console.error(error);
        });
    }

    private _obterIndicadorProducaoCorteMultiloja(): Promise<IndicadorProducaoCorteMultiloja[]> {
        return new Promise((resolve, reject) => {
            this._api.get('IndicadorProducaoCorteMultiloja').subscribe(response => resolve(JSON.parse(response._body)), reject);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/indicador-pro-corte-multilojas/indicador-pro-corte-multilojas.ts